import { useI18n } from 'vue-i18n';

type TranslateFn = ReturnType<typeof useI18n>['t'];

// Mapping of language translation labels (language_a) to database entries (Altkirchenslawisch)
const languageTranslationKeys: Record<string, string> = {
  Altkirchenslawisch: 'language_altkirchenslawisch',
  Altnordarabisch: 'language_altnordarabisch ',
  Altsüdarabisch: 'language_altsuedarabisch',
  'Altäthiopisch (Gəʿez)': 'language_altaethiopisch_gaez',
  Altäthiopisch: 'language_altaethiopisch',
  Arabisch: 'language_arabisch',
  'Aramäisch (Palmyrenisch)': 'language_aramaeisch_palmyrenisch',
  Aramäisch: 'language_aramaeisch',
  'Aramäisch/Hebräisch': 'language_aramaeisch_hebraeisch',
  Awestisch: 'language_awestisch',
  Griechisch: 'language_griechisch',
  Hebräisch: 'language_hebraeisch',
  Lateinisch: 'language_latein',
  'Mittelpersisch (Pahlavī)': 'language_mittelpersisch',
  Sogdisch: 'language_sogdisch',
  Sumerisch: 'language_sumerisch',
  Syrisch: 'language_syrisch',
};

export default function translateIntertextLanguage(
  t: TranslateFn,
  name?: string,
): string {
  if (!name) {
    return 'Sprache noch nicht zugeordnet';
  }

  const key = languageTranslationKeys[name];
  if (!key) {
    return name;
  }

  const translated = t(`intertext.${key}`);
  return !translated || translated === `intertext.${key}` ? name : translated;
}
